import { render, staticRenderFns } from "./MetaTemplateMessageModal.vue?vue&type=template&id=cb6b654e&scoped=true"
import script from "./MetaTemplateMessageModal.vue?vue&type=script&lang=js"
export * from "./MetaTemplateMessageModal.vue?vue&type=script&lang=js"
import style0 from "./MetaTemplateMessageModal.vue?vue&type=style&index=0&id=cb6b654e&prod&lang=scss&scoped=true"
import style1 from "./MetaTemplateMessageModal.vue?vue&type=style&index=1&id=cb6b654e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6b654e",
  null
  
)

export default component.exports